import React from 'react';
import { StaticReferencePage } from './StaticReferencePage';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { GekdCode } from '../../types';

export const GekdCodesPage: React.FC = () => {
  const { t } = useLanguage();
  const { gekdCodes } = useData();

  return (
    <StaticReferencePage<GekdCode>
      title={t('references.gekdCodes')}
      items={gekdCodes.items}
      columns={TABLE_COLUMNS.GEKD_CODES}
    />
  );
};
